var map = {
	"./ar/label.json": "./src/locales/ar/label.json",
	"./ar/menu.json": "./src/locales/ar/menu.json",
	"./ar/message.json": "./src/locales/ar/message.json",
	"./cz/label.json": "./src/locales/cz/label.json",
	"./cz/menu.json": "./src/locales/cz/menu.json",
	"./cz/message.json": "./src/locales/cz/message.json",
	"./de/label.json": "./src/locales/de/label.json",
	"./de/menu.json": "./src/locales/de/menu.json",
	"./de/message.json": "./src/locales/de/message.json",
	"./en/label.json": "./src/locales/en/label.json",
	"./en/menu.json": "./src/locales/en/menu.json",
	"./en/message.json": "./src/locales/en/message.json",
	"./es/label.json": "./src/locales/es/label.json",
	"./es/menu.json": "./src/locales/es/menu.json",
	"./es/message.json": "./src/locales/es/message.json",
	"./fr/label.json": "./src/locales/fr/label.json",
	"./fr/menu.json": "./src/locales/fr/menu.json",
	"./fr/message.json": "./src/locales/fr/message.json",
	"./hr/label.json": "./src/locales/hr/label.json",
	"./hr/menu.json": "./src/locales/hr/menu.json",
	"./hr/message.json": "./src/locales/hr/message.json",
	"./ja/label.json": "./src/locales/ja/label.json",
	"./ja/menu.json": "./src/locales/ja/menu.json",
	"./ja/message.json": "./src/locales/ja/message.json",
	"./ko/label.json": "./src/locales/ko/label.json",
	"./ko/menu.json": "./src/locales/ko/menu.json",
	"./ko/message.json": "./src/locales/ko/message.json",
	"./kz/label.json": "./src/locales/kz/label.json",
	"./kz/menu.json": "./src/locales/kz/menu.json",
	"./kz/message.json": "./src/locales/kz/message.json",
	"./pt/label.json": "./src/locales/pt/label.json",
	"./pt/menu.json": "./src/locales/pt/menu.json",
	"./pt/message.json": "./src/locales/pt/message.json",
	"./sh/label.json": "./src/locales/sh/label.json",
	"./sh/menu.json": "./src/locales/sh/menu.json",
	"./sh/message.json": "./src/locales/sh/message.json",
	"./sr/label.json": "./src/locales/sr/label.json",
	"./sr/menu.json": "./src/locales/sr/menu.json",
	"./sr/message.json": "./src/locales/sr/message.json",
	"./sv/label.json": "./src/locales/sv/label.json",
	"./sv/menu.json": "./src/locales/sv/menu.json",
	"./sv/message.json": "./src/locales/sv/message.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/locales sync recursive \\.json$";